import { render } from "./RollControls.vue?vue&type=template&id=60dedadc&scoped=true"
import script from "./RollControls.vue?vue&type=script&lang=js"
export * from "./RollControls.vue?vue&type=script&lang=js"

import "./RollControls.vue?vue&type=style&index=0&id=60dedadc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dedadc"]])

export default __exports__